import { RadioButton } from "primereact/radiobutton";
import { Image } from "primereact/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { selectedPayment } from "../../redux/slices/payments";
import AuthService from "../../services/autentication/auth.service";
import OrderService from "../../services/order/order.service";

const PaymentMode = ({ paymentmode }: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectedUserAddress = useAppSelector((state) => state.userAddress);
  const selectedPaymentMode = useAppSelector((state) => state.payments);
  const [selectedPaymentId, setSelectedPaymentId] = useState<number>(0);
  const isAdmin = useAppSelector((state) => state.isAdmin);
  const courier_charges = localStorage.getItem('courier-charges');
  const [isExecutive, setIsExecutive] = useState<boolean>(false);
  const [isCardAndUpiAllowed, setIsCardAndUpiAllowed] = useState<boolean>(false);
  let paymentmodesdata;

  const GetUserRoleId = () => {
    if (AuthService.isUserLoggedIn()) {
      const localData = localStorage.getItem("user");
      const parsedData = JSON.parse(localData !== null ? localData : "");
      return parsedData.roleID === 4 || parsedData.roleID === 8 ? true : false;
    } else {
      return false;
    }
  };

  // API call to check if Card and UPI options should be displayed
  const checkCardAndUpiEligibility = async () => {
    try {
      const data = await OrderService.checkCardAndUpiEligibility();
      setIsCardAndUpiAllowed(data.isSuccess);
    } catch (error) {
      console.error("Error checking Card and UPI eligibility:", error);
      setIsCardAndUpiAllowed(false);
    }
  };

  // Giving payment modes are must here because of 2% added calculation for payment gateway charges on other than cash on delivery and UPI.
  if (
    selectedUserAddress.selecedUserAddresses?.homeDeliveryAvailable &&
    (!isAdmin && !isExecutive)
  ) {
    if (courier_charges === '0') {
      paymentmodesdata = [
        {
          id: "1",
          mode: t("payment_mode1"),
          code: "COD",
          modeImage: process.env.PUBLIC_URL + "/assests/images/cod.jpg",
          isSelected: true,
        },
        {
          id: "7",
          mode: "Online Payment",
          code: "OPTONL",
          modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
          isSelected: false,
        },
      ];
    }
    else {
      paymentmodesdata = [
        {
          id: "7",
          mode: "Online Payment",
          code: "OPTONL",
          modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
          isSelected: false,
        }
      ];
    }
  } else if (isAdmin || isExecutive) {

    if (courier_charges === '0') {
      paymentmodesdata = [
        {
          id: "1",
          mode: t("payment_mode1"),
          code: "COD",
          modeImage: process.env.PUBLIC_URL + "/assests/images/cod.jpg",
          isSelected: true,
        },
        {
          id: "6",
          mode: "Payment Link",
          code: "",
          modeImage: process.env.PUBLIC_URL + "/assests/images/Betaallink.png",
          isSelected: true,
        },
        {
          id: "7",
          mode: "Online Payment",
          code: "OPTONL",
          modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
          isSelected: false,
        },
      ];
      // Add UPI and Card only if API check returns true
      if (isCardAndUpiAllowed) {
        paymentmodesdata.push(
          {
            id: "5",
            mode: "UPI",
            code: "OPTUPI",
            modeImage: process.env.PUBLIC_URL + "/assests/images/oup.jpg",
            isSelected: true,
          },
          {
            id: "9",
            mode: "Card",
            code: "OPTONL",
            modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
            isSelected: false,
          }
        );
      }
    }
    else {
      paymentmodesdata = [
        {
          id: "7",
          mode: "Online Payment",
          code: "OPTONL",
          modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
          isSelected: true,
        },
        {
          id: "6",
          mode: "Payment Link",
          code: "",
          modeImage: process.env.PUBLIC_URL + "/assests/images/Betaallink.png",
          isSelected: true,
        },     
      ];
      // Add UPI and Card only if API check returns true
      if (isCardAndUpiAllowed) {
        paymentmodesdata.push(
          {
            id: "5",
            mode: "UPI",
            code: "OPTUPI",
            modeImage: process.env.PUBLIC_URL + "/assests/images/oup.jpg",
            isSelected: true,
          },
          {
            id: "9",
            mode: "Card",
            code: "OPTONL",
            modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
            isSelected: false,
          }
        );
      }
    }

  } else {
    paymentmodesdata = [
      {
        id: "7",
        mode: "Online Payment",
        code: "OPTONL",
        modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
        isSelected: true,
      },
    ];
  }

  useEffect(() => {
    if (selectedPaymentMode.selectedPayment === null) {
      setSelectedPaymentId(0);
    } else {
      setSelectedPaymentId(selectedPaymentMode.selectedPayment.id);
    }
  });
  useEffect(() => {
    dispatch(selectedPayment(null));
    setSelectedPaymentId(0);
    setIsExecutive(GetUserRoleId);
    // Call API to check Card and UPI eligibility
    checkCardAndUpiEligibility();
  }, []);
  /// this part will removable after API.
  const savePaymentMode = (e: any, value: any) => {
    paymentmode(value);
    setSelectedPaymentId(value.id);
    dispatch(selectedPayment(value));
  };

  return (
    <>
      {paymentmodesdata.map((category) => {
        return (
          <div key={category.id} className="payment-card">
            <div key={category.id} className="flex flex-column gap-3">
              <div key={category.id} className="flex align-items-left">
                <div className="col-8 md:col-9 ">
                  <RadioButton
                    inputId={category.id}
                    name="category"
                    value={category}
                    onChange={(e) => savePaymentMode(e, e.value)}
                    checked={selectedPaymentId.toString() === category.id}
                  />
                  <label htmlFor={category.id} className="ml-2 font-medium">
                    {category.mode}
                  </label>
                </div>
                {/* <div className="col col-7"></div> */}
                <div className="col-4 md:col-3 text-right">
                  <div className="payment-mode-image">
                    <Image
                      src={category.modeImage}
                      alt={category.modeImage}
                      className="text-right"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PaymentMode;
